// Design's requirement to only show 5 dots of streaks maximum, even if the learner has reached beyond the requirement.
export const streaksNuggetsCdsCount = (progressAchieved: number) => {
  return Math.min(progressAchieved, 5);
};
